import { RiskManagementMetricType } from "$/__generated__/graphql";
import { LoadingSpinner } from "components/loaders";
import { SummariesToggle } from "components/toggles";

import DataTableVirtualized from "./DataTableVirtualized";
import type { RiskDataTablesProps } from "./types";
import { getSortedRowModel } from "@tanstack/react-table";

export const RiskDataTables = <TData,>({
  loading,
  showFoot,
  data,
  columns,
  setShowFoot,
  onFetchMore,
  isFetchingMore,
  selectionValue,
  systemValue,
  onSelectionChange,
  onSystemChange,
}: RiskDataTablesProps<TData>) => {
  const extraControls = showFoot ? (
    <SummariesToggle<RiskManagementMetricType>
      metricEnum={RiskManagementMetricType}
      selectionMetric={selectionValue}
      systemMetric={systemValue}
      onSelectionMetricChange={onSelectionChange}
      onSystemMetricChange={onSystemChange}
    />
  ) : undefined;

  return (
    <LoadingSpinner
      loading={loading && !isFetchingMore}
      className="h-full rounded shadow-column"
    >
      <DataTableVirtualized<TData>
        tableOptions={{
          columns,
          data,
          getSortedRowModel: getSortedRowModel<TData>(),
        }}
        showFoot={showFoot}
        setShowFoot={setShowFoot}
        onFetchMore={onFetchMore}
        extraControls={extraControls}
      />
    </LoadingSpinner>
  );
};

export default RiskDataTables;
